<template>
  <div class="homeleft">
    <div class="listai">
      <h1>
        什么是姓名图谱?
      </h1>
      <Row justify="center" class="titleTime">
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">作者：姓名图谱官方</Col>
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">时间：2020年1月1日</Col>
      </Row>
      <div class="articleImg">
        <img src="@/assets/number4.jpg" />
      </div>
      <p>
        <span class="ecolor">姓名图谱&nbsp;&nbsp;</span>是
        <span>西安暗能星系软件技术有限公司</span>&nbsp;&nbsp;开发的一款查名取名的小程序产品，解决各位给孩子取名过程中的烦恼；想必有过取名经验的人都有一种感觉，就是取名很难，这是因为我们没有足够的知识储备，没有想清楚这个名字对于孩子有什么样的寄寓，姓名图谱小程序就可以为大家解决取名的烦恼。产品有以下亮点：</p>
      <h2>一、姓名用字字典</h2>
      <p>
        <span class="ecolor">姓名图谱&nbsp;&nbsp;</span>中为大家提供了
        <span>《国家通用规范汉字表》</span>在取名之前，先翻阅字典，在翻得过程中可以收藏自己喜欢的字，字典分三个等级，一级字使用范围最广，二级字次之，生僻字属于三级字。</p>
        <div class="contentImg">
        <img src="@/assets/content1.jpg" />
      </div>
      <div class="content_c">
        <p>
        <span class="ecolor">姓名图谱&nbsp;&nbsp;</span>的
        <span>字典&nbsp;&nbsp;</span>中有公安部发布8105个常用字在我们字典中都有，并且这个功能有以下特点：</p>
        <p class="text-muted"><span>a.有这个字的词性，方便取名；</span></p>
        <p class="text-muted"><span>b.和这个字同音的字集合；</span></p>
        <p class="text-muted"><span>c.这个字常用的一些词；</span></p>
        <p class="text-muted"><span>d.和这个字相关的古今姓名；</span></p>
      </div>
       <h2>二、搜索</h2>
       <p class="text-muted">搜索功能不仅可以搜索名字，还可以查字；比如：你搜索<span>："香草"&nbsp;</span>就会有与香草有关的<span>&nbsp;字&nbsp;</span>都会在列表中显示，如下图：</p>
      <div class="contentImg">
        <img src="@/assets/content2.jpg" />
        <img src="@/assets/content3.jpg" />
      </div>
      <h2>三、姓名卡片</h2>
       <p class="text-muted"><span>&nbsp;姓名卡片包括：&nbsp;</span>名字卡片板块、<span class="ecolor">姓名总体得分、&nbsp;&nbsp;</span>地址板块、交互板块、标签板块、评价、类似名字推荐、百家姓详解反馈、说文解字、诗词典故、<span class="ecolor">关联查询、&nbsp;&nbsp;</span>统计分析等模块。如下图：</p>
        
      <div class="contentImg">
        <img src="@/assets/content4.jpg" />
        <img src="@/assets/content5.jpg" />
      </div>
      <div class="contentImg">
        <img src="@/assets/content7.jpg" />
        <img src="@/assets/content8.jpg" />
      </div>
      <h2>四、取名</h2>
       <p class="text-muted"><span>&nbsp;取名：&nbsp;</span>通过一系列的组合，使用人工智能技术，推荐出好听有寓意的名字；部分截图如下：</p>
        
      <div class="contentImg">
        <img src="@/assets/content9.jpg" />
        <img src="@/assets/content10.jpg" />
      </div>
      <div class="contentImg">
        <img src="@/assets/content11.jpg" />
        <img src="@/assets/content12.jpg" />
      </div>
      <p>取名字，是小事，也是大事。中国人每年有1400万左右的新生儿降生，取名几乎是是每个人都得面对的事儿，给1400万新生儿取名，尽量避免与历史上的名人、14亿的中国人重名。而公安部公布的取名用字只有8105个，想要一个好听、好读、好认且有寓意的名字也是很头疼的一件事，所以我们推出：姓名图谱帮您给宝宝取一个好名字！</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: []
    };
  }
};
</script>

<style scoped lang="scss">
.homeleft {
  .listai {
    padding: 16px;
    @media screen and(max-width:1200px) {
      h1 {
        margin: 15px 0;
        text-align: center;
      }
      h3 {
        margin: 10px 0;
        text-align: center;
      }
    }
    h1 {
      margin: 30px 0;
      text-align: center;
    }
    h2 {
      margin: 20px 0;
      text-align: center;
    }
    .titleTime {
      @media screen and(max-width:1200px) {
        height: 40px;
      line-height: 40px;
      }
      height: 80px;
      line-height: 80px;
      border-bottom: 1px #e8eaec solid;
      .titleName {
        color: #00d2a5;
        text-align: center;
      }
    }
    p {
      @media screen and(max-width:1200px) {
        padding: 5px;
      }
      padding: 10px 20px;
      font-size: 15px;
      text-indent: 28px;
      line-height: 28px;
      span {
        font-weight: bold;
      }
      .ecolor {
        color: #00d2a5;
      }
    }
    .articleImg {
      text-align: center;
      img {
        width: 800px;
      }
      @media screen and(max-width:1200px) {
        img {
          width: 300px;
        }
      }
    }
    .content_c {
      .text-muted {
        span {
            text-indent:28px;
        }
      }
      
    }
    .contentImg {
      text-align: center;
      img {
        width: 400px;
      }
      @media screen and(max-width:1200px) {
        img {
          width: 200px;
        }
      }
    }
  }
}
</style>
